// extracted by mini-css-extract-plugin
export default {"page":"News_page__FXsLy"};